import { handleActions } from 'redux-actions';
import { produce } from 'immer';

import actions from '../action';

const {
  actionTypes: { login },
} = actions;

const _token = window.localStorage.getItem('accessToken');
const _user = JSON.parse(window.localStorage.getItem('userInfo') || 'false');
const _sessionsData = (() => {
  try {
    const raw = window.sessionStorage.getItem('activeSessionsData');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();
const defaultState = {
  userInfo: _user || { accepted: undefined },
  token: _token || '',
  isLogin: _user && _token ? true : false,
  beforeLogout: false,
  sessionTimeout: false,
  activeSessions: _sessionsData?.sessions || [],
  currentSessionId: _sessionsData?.currentSessionId || null,
  activeCount: _sessionsData?.activeCount || 0,
};

export default handleActions(
  {
    [login.SAVE_USER_INFO]: (state, action) =>
      produce(state, (draft) => {
        draft.userInfo = action.payload;
        draft.isLogin = true;
      }),
    [login.DELETE_USER_INFO]: (state, action) =>
      produce(state, (draft) => {
        draft.userInfo = {};
        draft.isLogin = false;
        draft.beforeLogout = true;
      }),
    [login.ACCEPT_TERMS]: (state, action) => {
      window.localStorage.setItem(
        'userInfo',
        JSON.stringify(
          Object.assign(JSON.parse(window.localStorage.userInfo || '{}'), {
            accepted: action.payload,
          }),
        ),
      );
      return produce(state, (draft) => {
        draft.userInfo.accepted = action.payload;
      });
    },
    [login.ACCEPT_NEW_TERMS]: (state, action) => {
      window.localStorage.setItem(
        'userInfo',
        JSON.stringify(
          Object.assign(JSON.parse(window.localStorage.userInfo || '{}'), {
            newAccepted: action.payload,
          }),
        ),
      );
      return produce(state, (draft) => {
        draft.userInfo.newAccepted = action.payload;
      });
    },
    [login.UPDATE_USER_INFO]: (state, action) =>
      produce(state, (draft) => {
        draft.userInfo = Object.assign({}, state.userInfo, action.payload);
        draft.isLogin = true;
      }),
    [login.CHANGE_SESSION_TIMEOUT]: (state, action) =>
      produce(state, (draft) => {
        draft.sessionTimeout = action.payload;
      }),
    [login.SET_ACTIVE_SESSIONS]: (state, action) =>
      produce(state, (draft) => {
        draft.activeSessions = action.payload?.sessions || [];
        draft.currentSessionId = action.payload?.currentSessionId || null;
        draft.activeCount = action.payload?.activeCount ?? 0;
      }),
    [login.CLEAR_ACTIVE_SESSIONS]: (state) =>
      produce(state, (draft) => {
        draft.activeSessions = [];
        draft.currentSessionId = null;
        draft.activeCount = 0;
      }),
  },
  defaultState,
);
